<div class="profile-page">

  <div [ngClass]="isMobile ? 'mobile-header' : 'header'">
    <app-external-header
      style="z-index: 1000; position: relative; width: 100%"
      [isInboxPresent]="true"
      [isCompanyProfile]="isCompany()"
      [isProfile]="true"
      [showButtons]="false"
      [isMobile]="isMobile"
      [showProfilePicture]="true"
    ></app-external-header>
  </div>
  <!-- Mobile layout for profile picture + name + button -->
  <div class="mobile-profile-header" *ngIf="isMobile">
    <div class="profile-picture-center">
      <img
        class="user-image"
        [attr.alt]="'profile.picture' | translate"
        [class.loading]="!isImageLoaded"
        (load)="onImageLoad()"
        (error)="onImageError($event)"
        loading="lazy"
        [src]="resolvedProfileImageUrl"
      />
    </div>
    <div class="user-name-mobile">
      {{ user?.firstname }} {{ user?.lastname }}
      <mat-icon *ngIf="completionPercentage === 100" class="verified-icon" color="primary">
        verified
      </mat-icon>
    </div>

    <div class="mobile-action-buttons" *ngIf="isUserProfile && !isMobile">
      <app-button
        (click)="navigateToApplicationTracking()"
        [label]="'profile.track_applications' | translate"
        [type]="ButtonType.PRIMARY"
        [state]="ButtonState.FOCUSED"
        [size]="ButtonSize.MEDIUM"
      ></app-button>
    </div>
  </div>
  <ng-container *ngIf="!isLoading; else loadingTemplate">
    <div class="main-wrapper">
      <div class="main-layout">
        <div class="sidebar">
          <div class="profile-picture-wrapper" *ngIf="!isMobile">
            <ng-container *ngIf="completionPercentage < 100 && isUserProfile && !isMobile">
              <div class="completion-circle">
                <svg [ngStyle]="{ stroke: completionColor }" class="circular-chart" viewBox="0 0 36 36">
                  <path class="circle-bg"
                        d="M18 2.0845a 15.9155 15.9155 0 0 1 0 31.831a 15.9155 15.9155 0 0 1 0 -31.831"/>
                  <path class="circle" [attr.stroke-dasharray]="completionPercentage + ', 100'"
                        d="M18 2.0845a 15.9155 15.9155 0 0 1 0 31.831a 15.9155 15.9155 0 0 1 0 -31.831"/>
                </svg>
              </div>
              <div class="percentage-wrapper">
                <div class="percentage-text">
                  {{ completionPercentage | number: '1.0-0' }}%
                  <span class="tooltip-text">{{ 'profile.profile_verified' | translate }}</span>
                </div>
              </div>
            </ng-container>

            <div class="profile-picture">
              <img
                class="user-image"
                [attr.alt]="'profile.picture' | translate"
                [class.loading]="!isImageLoaded"
                (load)="onImageLoad()"
                (error)="onImageError($event)"
                loading="lazy"
                [src]="resolvedProfileImageUrl"
              />
            </div>

          </div>

          <div class="profile-info">
            <div class="name-actions-wrapper" *ngIf="!isMobile">
              <div class="user-name">
                {{ user?.firstname }} {{ user?.lastname }}
                <mat-icon *ngIf="completionPercentage === 100" class="verified-icon" color="primary">
                  verified
                </mat-icon>
              </div>

              <div class="action-buttons" *ngIf="isUserProfile && !isMobile">
                <app-button
                  (click)="navigateToApplicationTracking()"
                  [label]="'profile.track_applications' | translate"
                  [type]="ButtonType.PRIMARY"
                  [state]="ButtonState.FOCUSED"
                  [size]="ButtonSize.LARGE"
                ></app-button>
              </div>

            </div>
          </div>
        </div>

        <div class="job-offers">
          <section class="banner">
            <div class="banner-content">
              <p class="cta-description">
                {{ 'profile.banner.title' | translate }}<br/>
                <span class="sub-text">{{ 'profile.banner.subtitle' | translate }}</span>
              </p>
              <div class="create-offer-button">
                <ng-container *ngIf="isUserProfile">
                  <app-button
                    (click)="goToMainPage()"
                    [label]="'profile.banner.button' | translate"
                    [showLeftIcon]="true"
                    [leftIcon]="'assets/icons/loop.png'"
                    [size]="ButtonSize.MEDIUM"
                    [state]="ButtonState.REGULAR"
                    [type]="ButtonType.SECONDARY"
                  ></app-button>
                </ng-container>
              </div>
            </div>
            <div class="banner-image" *ngIf="!isMobile">
              <img src="assets/experience.png" alt="Dashboard preview"/>
              <img class="user-avatar" src="assets/happywoman.png" alt="User"/>
            </div>
          </section>

          <div class="profile-content" [ngClass]="{ 'column-layout': isMobile }">
            <div class="left-column">

              <div class="box bio-box">
                <div class="title-edit">
                  <div class="title">Bio</div>
                  <ng-container *ngIf="isUserProfile && !isMobile">
                    <img
                      class="edit-icon"
                      src="assets/icons/edit2.png"
                      alt="Edit"
                      (click)="toggleEditBio()"
                    />
                  </ng-container>
                  <ng-container *ngIf="isUserProfile && isMobile">
                    <button class="edit-icon-mobile" (click)="toggleEditBio()">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </ng-container>
                </div>

                <div *ngIf="!isEditingBio; else editBioTemplate" class="content-box">
                  <div>
                    {{ user?.motivation || ('profile.profile_section_overview_empty' | translate) }}
                  </div>

                  <div *ngIf="isMotivationTooShort" class="motivation-warning">
                    {{ motivationMessage }}
                  </div>

                  <div *ngIf="user?.motivation?.length > 400" class="show-more-toggle" (click)="toggleBioExpand()">
                    <!-- Text would never exceed the limit, 400 characters are always shown no need for Show more -->
                    {{ isBioExpanded ? ('profile.show_less' | translate) : ('profile.show_more' | translate) }}
                  </div>
                </div>
                <ng-template #editBioTemplate>
                  <div style="padding: 1rem">
                    <app-input-area (savedText)="saveBio($event)" [defaultText]="user?.motivation" [isEditable]="true"
                                    [withSubmit]="true">{{ 'profile.enter_bio' | translate }}
                    </app-input-area>
                  </div>
                </ng-template>
              </div>

              <!-- when you click on Today in edit experience calender it is not selected as a date and you cant save -->
              <div class="box experience-box">
                <div class="title-edit">
                  <div class="title">{{ 'profile.experience' | translate }}</div>
                  <ng-container *ngIf="isUserProfile && !isMobile">
                    <img
                      class="edit-icon"
                      src="assets/add.png"
                      alt="Edit"
                      (click)="openWorkExperienceManager()"/>
                  </ng-container>
                  <ng-container *ngIf="isUserProfile && isMobile">
                    <button class="edit-icon-mobile" (click)="openWorkExperienceManager()">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </ng-container>
                </div>

                <div style="padding: 1rem;">
                  <ng-container *ngIf="user?.workExperience?.length > 0; else noExperienceData">

                    <div *ngFor="let exp of user.workExperience; let last = last" class="experience-entry">
                      <div class="experience-icon">
                        <img src="assets/icons/experience-education.png" alt="Experience Icon"/>
                      </div>
                      <div class="experience-content-wrapper">
                        <div class="experience-actions" *ngIf="isUserProfile && !isMobile">
                          <ng-container>

                            <img class="edit-icon" src="assets/icons/edit2.png" alt="Edit"
                                 (click)="openWorkExperienceManager(exp)"/>
                            <img class="edit-icon" src="assets/icons/delete.png" alt="Delete"
                                 (click)="deleteExperience(exp)"/>
                          </ng-container>
                        </div>
                        <div class="mobile-experience-actions" *ngIf="isUserProfile && isMobile">
                          <ng-container>
                            <img class="mobile-edit-icon" src="assets/icons/edit2.png" alt="Edit"
                                 (click)="openWorkExperienceManager(exp)"/>
                            <img class="mobile-edit-icon" src="assets/icons/delete.png" alt="Delete"
                                 (click)="deleteExperience(exp)"/>
                          </ng-container>
                        </div>
                        <div class="experience-header">{{ exp.jobTitle }}</div>
                        <div class="experience-organization">{{ exp.organization }}</div>
                        <div class="date-range">
                          {{ exp.startDate | date: 'MMM yyyy' }} -
                          {{ exp.completionDate ? (exp.completionDate | date: 'MMM yyyy') : ('profile.present' | translate) }}
                          | {{ exp.location }}
                        </div>
                        <div class="experience-description">{{ exp.jobDescription }}</div>
                      </div>
                    </div>
                  </ng-container>
                </div>

                <ng-template #noExperienceData>
                  <div class="empty-data-message">
                    {{ 'profile.experience_empty' | translate }}
                  </div>
                </ng-template>
              </div>

              <div class="box experience-box">
                <div class="title-edit">
                  <div class="title">{{ 'profile.education' | translate }}</div>
                  <ng-container *ngIf="isUserProfile && !isMobile">

                    <img
                      class="edit-icon"
                      src="assets/add.png"
                      alt="Edit"
                      (click)="openEducationManager()"/>
                  </ng-container>
                  <ng-container *ngIf="isUserProfile && isMobile">
                    <button class="edit-icon-mobile" (click)="openEducationManager()">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </ng-container>
                </div>

                <div style="padding: 1rem;">
                  <ng-container *ngIf="user?.education?.length > 0; else noEducationData">
                    <div *ngFor="let edu of user.education" class="experience-entry">
                      <div class="experience-icon">
                        <img src="assets/icons/experience-education.png" alt="Experience Icon"/>
                      </div>
                      <div class="experience-content-wrapper">
                        <div class="experience-actions" *ngIf="isUserProfile && !isMobile">
                          <ng-container>
                            <img class="edit-icon" src="assets/icons/edit2.png" alt="Edit"
                                 (click)="openEducationManager(edu)"/>
                            <img class="edit-icon" src="assets/icons/delete.png" alt="Delete"
                                 (click)="deleteEducation(edu)"/>
                          </ng-container>
                          <ng-container *ngIf="isUserProfile && isMobile">
                            <img class="mobile-edit-icon" src="assets/icons/edit2.png" alt="Edit"
                                 (click)="openEducationManager(edu)"/>
                            <img class="mobile-edit-icon" src="assets/icons/delete.png" alt="Delete"
                                 (click)="deleteEducation(edu)"/>
                          </ng-container>
                        </div>
                        <div class="mobile-experience-actions" *ngIf="isUserProfile && isMobile">
                          <ng-container>
                            <img class="mobile-edit-icon" src="assets/icons/edit2.png" alt="Edit"
                                 (click)="openEducationManager(edu)"/>
                            <img class="mobile-edit-icon" src="assets/icons/delete.png" alt="Delete"
                                 (click)="deleteEducation(edu)"/>
                          </ng-container>
                        </div>
                        <div class="experience-header">{{ edu.organization }}</div>
                        <div class="experience-organization">{{ edu.education }}</div>
                        <div class="date-range">
                          {{ edu.startDate | date: 'MMM yyyy' }} -
                          {{ edu.completionDate ? (edu.completionDate | date: 'MMM yyyy') : ('profile.present' | translate) }}
                          | {{ edu.location }}
                        </div>
                      </div>
                    </div>

                  </ng-container>

                  <ng-template #noEducationData>
                    <div class="empty-data-message">
                      {{ 'profile.education_empty' | translate }}
                    </div>
                  </ng-template>
                </div>
              </div>


            </div>

            <div class="right-column">

              <div class="box">
                <div class="title-edit">
                  <div class="title">{{ 'profile.languages' | translate }}</div>
                  <ng-container *ngIf="!isMobile">
                    <ng-container *ngIf="isUserProfile && !isMobile">
                      <img (click)="editProfileSection('languages', { dataToEdit: true, section: 'language' })"
                           *ngIf="isUserProfile && !isMobile"
                           class="edit-icon"
                           src="assets/icons/edit2.png">
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="isMobile">
                    <ng-container *ngIf="isUserProfile && isMobile">
                      <button class="edit-icon-mobile"
                              (click)="editProfileSection('languages', { dataToEdit: true, section: 'language' })">
                        <mat-icon>edit</mat-icon>
                      </button>
                    </ng-container>
                  </ng-container>
                </div>
                <div *ngIf="user?.languages?.length; else noLanguagesData" class="content-box">
                  <!-- <div class="lang-fluent">{{ 'profile.fluent' | translate }}</div> -->
                  <div *ngFor="let lang of user?.languages" class="language-chip">
                    <img [src]="getFlagSrc(lang)" class="flag-icon">
                    <span class="language-name">{{ lang }}</span>
                  </div>
                </div>
                <ng-template #noLanguagesData>
                  <div class="empty-data-message">
                    {{ 'profile.languages_empty' | translate }}
                    <ng-container *ngIf="isUserProfile && !isMobile">
                      {{ 'random_phrases.please' | translate }} <span
                      (click)="editProfileSection('languages', { dataToEdit: true, section: 'language' })"
                      class="edit-link">{{ 'random_phrases.add_languages' | translate }}</span> {{ 'random_phrases.to_complete_your_profile'| translate }}
                    </ng-container>
                    <ng-container *ngIf="isUserProfile && isMobile">
                      <button class="edit-icon-mobile"
                              (click)="editProfileSection('languages', { dataToEdit: true, section: 'language' })">
                        <mat-icon>edit</mat-icon>
                      </button>
                    </ng-container>
                  </div>
                </ng-template>
              </div>

              <div class="box">
                <div class="title-edit">
                  <div class="title">{{ 'profile.my_cv' | translate }}</div>
                  <ng-container *ngIf="isUserProfile && !isMobile">
                    <img
                      class="edit-icon"
                      src="assets/icons/edit2.png"
                      alt="Edit"
                      (click)="editCv()"
                    />
                  </ng-container>
                  <ng-container *ngIf="isUserProfile && isMobile">
                    <button class="edit-icon-mobile" (click)="editCv()">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </ng-container>
                </div>

                <div *ngIf="cv?.url; else noCvData" class="cv-file-box">
                  <div class="my-cv-file" (click)="onCvClick()">
                    <img src="assets/icons/file.svg" class="cv-icon" alt="CV icon"/>
                    <span class="cv-filename">CV.pdf</span>
                  </div>
                </div>


                <ng-template #noCvData>
                  <div class="empty-data-message">
                    {{ 'profile.cv_not_uploaded' | translate }}
                    <ng-container *ngIf="isUserProfile && !isMobile">
                      {{ 'random_phrases.please' | translate }}
                      <span (click)="editCv()" class="edit-link">
                      {{ 'profile.add_cv' | translate }}
                      </span>
                      {{ 'random_phrases.to_complete_your_profile' | translate }}
                    </ng-container>
                  </div>
                </ng-template>
              </div>

              <div class="box certificate-list-box">
                <div class="title-edit">
                  <div class="title">{{ 'profile.additional_certificates' | translate }}</div>
                  <ng-container *ngIf="isUserProfile && !isMobile">
                    <img
                      class="edit-icon"
                      src="assets/icons/edit2.png"
                      alt="Edit"
                      (click)="openCertificateListDialog()"
                    />
                  </ng-container>
                  <ng-container *ngIf="isUserProfile && isMobile">
                    <button class="edit-icon-mobile" (click)="openCertificateListDialog()">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </ng-container>
                </div>


                <ng-container *ngIf="certificates?.length > 0; else noOtherCertificates">
                  <div *ngFor="let cert of certificates" class="certificate-entry">
                    <div style="display: flex; flex-direction: row; gap: 0.75rem;">
                      <img src="../../../../../assets/icons/file.svg" style="width:20px; height: 24px;"
                           class="cv-icon" alt="Certificate icon"/>
                      <div class="cert-info">
                        <span style="cursor: pointer;" (click)="onCertificateClick(cert)">
                          {{ cert.title }}
                          <ng-container *ngIf="cert.description && cert.description !== 'n/a'">({{ cert.description }}
                            )</ng-container>
                        </span>
                      </div>
                    </div>
                    <ng-container *ngIf="isUserProfile && !isMobile">
                      <img
                        class="certif-icon"
                        src="assets/icons/delete.png"
                        alt="Delete"
                        (click)="deleteCertificate(cert)"
                      />
                    </ng-container>
                    <ng-container *ngIf="isUserProfile && isMobile">
                      <img
                        class="certif-icon"
                        src="assets/icons/delete.png"
                        alt="Delete"
                        (click)="deleteCertificate(cert)"
                      />
                    </ng-container>

                  </div>
                </ng-container>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>


  <ng-template #loadingTemplate>
    <app-load-mask></app-load-mask>
  </ng-template>

  <ng-template #noOtherCertificates>
    <div class="empty-data-message">
      {{ 'profile.additional_certificates_empty' | translate }}
    </div>
  </ng-template>

  <div class="profile-account-deletion">
    <a routerLink="/account-deletion" class="profile-account-deletion__link">
      {{ 'profile.account_deletion' | translate }}
    </a>
  </div>

  <div class="footer-class">
    <div class="footer-container">
      <app-footer></app-footer>
    </div>
  </div>
</div>
